import { render } from "./keyMake.vue?vue&type=template&id=b07829ce&scoped=true"
import script from "./keyMake.vue?vue&type=script&lang=js"
export * from "./keyMake.vue?vue&type=script&lang=js"

import "./keyMake.vue?vue&type=style&index=0&id=b07829ce&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07829ce"]])

export default __exports__